import { http } from '@/services/config';

export default {
    getByAllotment: allotmentId => http.get(`api/v1/tabela-precos/get-by-allotment/${allotmentId}`),

    create: data => http.post('api/v1/tabela-precos', data),

    update: data => http.patch(`api/v1/tabela-precos/${data.id}`, data),

    delete: id => http.delete(`api/v1/tabela-precos/${id}`),

    updateDownloadPermissions: (id, data) => http.patch(`api/v1/tabela-precos/${id}/download-permissions`, data),

    generate: data => http.post('api/v1/tabela-precos/gerar', data),

    getDownloadUrl: priceTableId => http.get(`api/v1/tabela-precos/${priceTableId}/download-url`),
};
